<template>
  <Head title="Playbooks - Experiment Variant Overview" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <experiment-treatment-overview 
            :client="client" 
            :playbook="playbook" 
            :asset_types="asset_types" 
            :concepts="concepts"
          ></experiment-treatment-overview>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

const props = defineProps({
  client: Object,
  playbook: Object,
  asset_types: Array,
  concepts: Array
});

// Set window globals immediately for legacy component compatibility
window.__CLIENT__ = props.client;
</script>

